import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { useHistory } from 'react-router-dom';
import { UnityView } from '@app/core/Elements/Unity';
import { Blocks } from '@app/core/Elements/Blocks';
import { firebase } from '@app/services';
import { selectConfig, selectPlayer, selectStage } from '@app/store/selectors/data.selectors';

interface Props { }

export const Progress: React.FC<Props> = () =>
{
    const config = useSelector(selectConfig);
    const player = useSelector(selectPlayer);
    const stage = useSelector(selectStage);

    return (
        <>
            <div className="header"><img src={"/assets/branding.png"}></img></div>
            <div className="help">
                <div className="effect"></div>
                <div className="text">{stage?.help?.task}</div>
            </div>
        </>
    );
};
